import { createClient } from '@supabase/supabase-js';

// שכבת רשת עמידה (בהשראת ironbarFetch של IronBar) תתווסף כשנגיע ל-offline;
// בשלב ה-MVP — קליינט ישיר.
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
